// extracted by mini-css-extract-plugin
module.exports = {"header":"sectionHeader_header__LUfEv","title":"sectionHeader_title__16SXm"};